import { Grid, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useKeycloak } from '@react-keycloak/web';
import { useNavigate } from 'react-router-dom';
import PlanCard from '../PlanCard';
import { FREE_FEATURES, PREMIUM_FEATURES, getFormattedFeatures } from '../../config/pricingFeatures';

function PricingTable({ pricing, loading: pricingLoading }) {
  const { t } = useTranslation();
  const { keycloak } = useKeycloak();
  const navigate = useNavigate();

  const handleGetStartedFree = () => {
    if (keycloak.authenticated) {
      navigate('/home');
    } else {
      keycloak.register({ redirectUri: window.location.origin + '/home' });
    }
  };

  const handleGetStartedPremium = () => {
    if (keycloak.authenticated) {
      navigate('/plan-selection');
    } else {
      keycloak.register({ redirectUri: window.location.origin + '/plan-selection' });
    }
  };

  // Get the current price (monthly only)
  const getCurrentPrice = () => {
    if (pricingLoading) {
      return <Skeleton width="100px" />;
    }

    // Fallback price for monthly
    const getFallbackPrice = () => {
      return `39 SEK${t('pricing.billing.intervals.month')}`;
    };

    if (!pricing?.prices?.monthly) {
      return getFallbackPrice();
    }

    const currentPrice = pricing.prices.monthly;
    return `${currentPrice.formatted.amount} ${currentPrice.formatted.currency}${t(`pricing.billing.intervals.${currentPrice.interval}`)}`;
  };

  const freeFeatures = getFormattedFeatures(t, FREE_FEATURES);
  const premiumFeatures = getFormattedFeatures(t, PREMIUM_FEATURES);

  return (
    <Grid container spacing={4} sx={{ mt: 0, px: { xs: 2, sm: 3, md: 4 }, alignItems: { xs: 'flex-start', md: 'stretch' } }}>
      {/* Free Plan */}
      <Grid item xs={12} md={6} sx={{ display: 'flex', order: { xs: 2, md: 0 } }}>
        <PlanCard
          variant="free"
          name={t('pricing.free.name')}
          price={t('pricing.free.price')}
          subtitle={t('pricing.free.subtitle')}
          features={freeFeatures}
          buttonText={t('pricing.free.cta')}
          onButtonClick={handleGetStartedFree}
          buttonPosition="top"
        />
      </Grid>

      {/* Premium Plan */}
      <Grid item xs={12} md={6} sx={{ display: 'flex', order: { xs: 1, md: 0 } }}>
        <PlanCard
          variant="premium"
          name={t('pricing.premium.name')}
          price={getCurrentPrice()}
          subtitle={t('pricing.premium.subtitle')}
          features={premiumFeatures}
          buttonText={t('pricing.premium.cta')}
          onButtonClick={handleGetStartedPremium}
          badge={t('pricing.premium.badge')}
          buttonPosition="top"
        />
      </Grid>
    </Grid>
  );
}

export default PricingTable;
